import { render, staticRenderFns } from "./PreguntaControl.vue?vue&type=template&id=779a1872&scoped=true"
import script from "./PreguntaControl.vue?vue&type=script&lang=js"
export * from "./PreguntaControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779a1872",
  null
  
)

export default component.exports